export enum Types {
	CADASTRAR_CIDADAO_AUTISTA_REQUEST = '@iirgd/CADASTRAR_CIDADAO_AUTISTA_REQUEST',
	CADASTRAR_CIDADAO_AUTISTA_SUCCESS = '@iirgd/CADASTRAR_CIDADAO_AUTISTA_SUCCESS',
	CADASTRAR_CIDADAO_AUTISTA_FAILURE = '@iirgd/CADASTRAR_CIDADAO_AUTISTA_FAILURE',
	CADASTRAR_CIDADAO_AUTISTA_CLEAR = '@iirgd/CADASTRAR_CIDADAO_AUTISTA_CLEAR',
}

export interface CadastrarCidadaoAutista {
	data: CadastrarCidadaoAutistaData | null;
	status: number;
}

export interface CadastrarCidadaoAutistaRequest {
	header: {
		usuario: string;
		senha: string;
	};
	requestData: {
		numeroRg: string;
		digitoRg: string;
		ciptea: boolean;
		dataValidade: string | null;
		responsavel: {
			cpf: string;
			nome: string;
			logradouro: string;
			logradouroNumero: string;
			logradouroComplemento: string;
			logradouroBairro: string;
			logradouroCEP: string;
			logradouroMunicipioCodigo: string;
			logradouroMunicipioDigito: string;
			emailUsuario: string;
			emailDominio: string;
			telefoneDDD: string;
			telefoneNumero: string;
		};
	};
}

export interface CadastrarCidadaoAutistaData {
	numeroRg: string;
	digitoRg: string;
	nome: string;
	dataNascimento: string;
	ciptea: boolean;
	dataValidade: string;
	responsavel: {
		cpf: string;
		nome: string;
		logradouro: string;
		logradouroNumero: string;
		logradouroComplemento: string;
		logradouroBairro: string;
		logradouroCEP: string;
		logradouroMunicipioCodigo: string;
		logradouroMunicipioDigito: string;
		emailUsuario: string;
		emailDominio: string;
		telefoneDDD: string;
		telefoneNumero: string;
	};
}
